module.exports = __webpack_public_path__ + "img/25_52.195ddd6f.png";